import { Button, colors, VStack } from "goi_common";
import React, { useState } from "react";
import ConsultPhoneFormSection from "./ConsultPhoneFormSection";
import { useConsultSubmit } from "@/hooks/useConsultSubmit";
import { buildCallLeadMemo } from "@/utils/buildCallLeadMemo";

export default function ConsultPhoneSubmitSection({
  trigger = "인입 페이지",
}: {
  trigger?: string;
}) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [privateAgree, setPrivateAgree] = useState(false);
  const [marketingAgree, setMarketingAgree] = useState(false);

  const { loading, submitConsult } = useConsultSubmit({
    path: "call_lead",
    onSuccess: () => {
      setPhoneNumber("");
      setPrivateAgree(false);
      setMarketingAgree(false);
      alert(
        "안내 신청이 완료되었습니다. 1영입일 내로 빠르게 연락드리겠습니다."
      );
    },
  });

  const onSubmit = () => {
    if (loading) return;
    if (!phoneNumber) {
      alert("핸드폰 번호를 입력해주세요.");
      return;
    }
    if (!/^010[1-9]\d{7}$/.test(phoneNumber.replaceAll("-", ""))) {
      alert("핸드폰 번호 형식을 확인해주세요.");
      return;
    }
    if (!privateAgree) {
      alert("개인정보 수집 및 이용에 동의해주세요.");
      return;
    }

    const messageText = buildCallLeadMemo({ trigger });

    submitConsult({ phone: phoneNumber, memo: messageText, marketingAgree });
  };

  return (
    <VStack>
      <ConsultPhoneFormSection
        phoneNumber={phoneNumber}
        setPhoneNumber={setPhoneNumber}
        privateAgree={privateAgree}
        setPrivateAgree={setPrivateAgree}
        marketingAgree={marketingAgree}
        setMarketingAgree={setMarketingAgree}
      />
      <Button
        css={{
          marginTop: "18px",
          backgroundColor: colors.black,
          padding: "8px 12px",
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: "700",
          color: colors.white,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        className="white button"
        onClick={onSubmit}
      >
        {"추가 혜택 받기"}
      </Button>
    </VStack>
  );
}
